// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__r4vwL","filled":"IconReviewStar_filled__2R-tB"};